import * as z from 'zod';

import { BankruptcyId } from '../BrandedIds';
import { zodJSInstantDate, zodJSPlainDate } from '../dates/BrandedDate';
import { zodBrandedUuid } from '../utils';
import { AuthorizedContactPaymentPayer, BorrowerPaymentPayer, EntityPaymentPayer } from './Payments';

export const BankruptcyChapter = z.enum(['CHAPTER_7', 'CHAPTER_11', 'CHAPTER_12', 'CHAPTER_13']);
export type BankruptcyChapter = z.infer<typeof BankruptcyChapter>;

export const BankruptcyFiledBy = z.discriminatedUnion('type', [
  BorrowerPaymentPayer,
  EntityPaymentPayer,
  AuthorizedContactPaymentPayer,
]);
export type BankruptcyFiledBy = z.infer<typeof BankruptcyFiledBy>;

export const Bankruptcy = z.object({
  id: zodBrandedUuid<BankruptcyId>(),
  chapter: BankruptcyChapter,
  filedAt: zodJSPlainDate,
  filedBy: BankruptcyFiledBy.array().min(1, { message: 'At least one filer required' }).optional(), // TODO make required when migration has run
  completedAt: zodJSPlainDate.optional(),

  createdAt: zodJSInstantDate,
  updatedAt: zodJSInstantDate,
});
export type Bankruptcy = z.infer<typeof Bankruptcy>;

export const BankruptcyInput = Bankruptcy.pick({
  id: true,
  chapter: true,
  filedAt: true,
  filedBy: true,
  completedAt: true,
}).partial({ id: true });
export type BankruptcyInput = z.infer<typeof BankruptcyInput>;
